import { render, staticRenderFns } from "./WorkOrderDetailEmailModal.vue?vue&type=template&id=b489c8cc&"
import script from "./WorkOrderDetailEmailModal.vue?vue&type=script&lang=js&"
export * from "./WorkOrderDetailEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports